import React, { Component } from 'react'
import { inject, observer, PropTypes } from 'mobx-react'
import Page from './Page'
import Loading from '../components/Loading'
import Reviews from '../components/Reviews'
import object_value from '../api/object_value'

@inject('userById')
@observer
class ProfileByIdPage extends Component {
  constructor(props) {
    super(props)

    const page_id = object_value(props, 'match.params.id')
    const { userById } = props
    const user = userById.get(page_id)
    console.log('ProfileByIdPage.js - constructor() - user', user)

    this.state = {
      page_id
    }
  }

  render () {
    const { userById } = this.props
    const user = userById.data
    console.log('ProfileByIdPage.js - user:', user)

    if (!userById.loaded) {
     return (<div><Loading /></div>)
    }

    if (!userById.data) {
      return (
       <Page title='Profile'>
         <article className='b-info'>
           <h2 className='b-info-title'>Nutzer nicht gefunden</h2>
         </article>
       </Page>
      )
    }

    const image_url = user.image_url
    const image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    let surname = user.surname ? user.surname.charAt(0) + '.' : ''
    let name = user.prename + ' ' + surname

    let reviews = user.ratings_organiser

    return (
      <Page title='Profil'>
        <section className='b-profile'>
          <div className='b-profile-inner'>

            <nav className='b-profile-menu'>
              <div className='b-profile-menu-inner'>
              </div>
            </nav>

            <div className='b-profile-main'>
              <div className='b-profile-author'>
                <div className='b-profile-author-picture'
                     style={image_style} />
                <div className='b-profile-author-name'>{name}</div>
              </div>
              <p className='lead'>{user.description}</p>
              {/*<p className='not-working'>
                Quisque placerat facilisis egestas cillum dolore. Pellentesque habitant morbi tristique senectus et
                netus. Morbi fringilla convallis sapien, id pulvinar odio volutpat. Mercedem aut nummos unde unde
                extrica.
              </p>*/}
              <hr />
              {reviews &&
              <div className='b-profile-block'>
                <div className='b-profile-block-label'>Bewertungen</div>
                <div className='b-profile-block-value'>
                  {reviews.length > 0
                    ? <Reviews reviews={reviews} />
                    : <span>Dieser Nutzer hat noch keine Bewertungen</span>
                  }
                </div>
              </div>}
            </div>
          </div>
        </section>
      </Page>
    )
  }
}

ProfileByIdPage.propTypes = {
  userById: PropTypes.observableObject
}

export default ProfileByIdPage



// WEBPACK FOOTER //
// ./src/containers/ProfileByIdPage.js